import ActionType from './action-types'
import { Api }    from '../lib'

const node_api = new Api({node_api: true})

const get = () => dispatch =>
  node_api.get('subscription')

    .then(result => dispatch({
      type: ActionType.RECEIVED_SUBSCRIPTIONS,
      payload: result.data
    }))


export default {
  get,
}
